var _excluded = ["autoFocus", "autoGrow", "className", "disabled", "disableGrammarly", "hint", "label", "maxLength", "onBlur", "onChange", "onFocus", "onKeyUp", "onPaste", "placeholder", "readOnly", "required", "rules", "rows", "validateOnBlur", "validationState", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext, useEffect, useRef, useState } from "react";
import AInputBase from "../AInputBase";
import { AFormContext } from "../AForm";
import { useCombinedRefs } from "../../utils/hooks";
import "./ATextarea.scss";
var textareaCounter = 0;
var ATextarea = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var autoFocus = _ref.autoFocus,
    autoGrow = _ref.autoGrow,
    propsClassName = _ref.className,
    disabled = _ref.disabled,
    disableGrammarly = _ref.disableGrammarly,
    hint = _ref.hint,
    label = _ref.label,
    maxLength = _ref.maxLength,
    _onBlur = _ref.onBlur,
    propsOnChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    onKeyUp = _ref.onKeyUp,
    onPaste = _ref.onPaste,
    placeholder = _ref.placeholder,
    readOnly = _ref.readOnly,
    required = _ref.required,
    rules = _ref.rules,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 3 : _ref$rows,
    validateOnBlur = _ref.validateOnBlur,
    _ref$validationState = _ref.validationState,
    validationState = _ref$validationState === void 0 ? "default" : _ref$validationState,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var textareaRef = useRef(null);
  var combinedRef = useCombinedRefs(ref, textareaRef);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = useState(textareaCounter++),
    _useState4 = _slicedToArray(_useState3, 1),
    textareaId = _useState4[0];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = useState(validationState),
    _useState8 = _slicedToArray(_useState7, 2),
    workingValidationState = _useState8[0],
    setWorkingValidationState = _useState8[1];
  useEffect(function () {
    if (!autoFocus || typeof document === "undefined" || !combinedRef || !combinedRef.current || document.activeElement === combinedRef.current.querySelector(".a-textarea__field")) return;
    combinedRef.current.querySelector(".a-textarea__field").focus();
  }, [autoFocus, combinedRef]);
  useEffect(function () {
    if (autoGrow) {
      calculateInputHeight();
    } else {
      var input = combinedRef.current && combinedRef.current.querySelector(".a-textarea__field");
      if (!input) return;
      input.style.height = "auto";
    }
  }, [autoGrow]); // eslint-disable-line react-hooks/exhaustive-deps

  var _useContext = useContext(AFormContext),
    register = _useContext.register,
    unregister = _useContext.unregister;
  useEffect(function () {
    setWorkingValidationState(validationState);
  }, [validationState]);
  useEffect(function () {
    if (register) {
      register("a-textarea_".concat(textareaId), {
        reset: reset,
        validate: validate
      });
    }
  }, [validationState, value, rules]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (unregister) {
      return function () {
        return unregister("a-textarea_".concat(textareaId));
      };
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var calculateInputHeight = function calculateInputHeight() {
    var input = combinedRef.current && combinedRef.current.querySelector(".a-textarea__field");
    if (!input) return;
    input.style.height = "0";
    var height = input.scrollHeight;
    var minHeight = rows * 18.4; /* <- row height */
    input.style.height = Math.max(minHeight, height) + "px";
  };
  var validate = function validate() {
    var testValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : value;
    if (rules || required) {
      var workingRules = [];
      if (rules) {
        workingRules = _toConsumableArray(rules);
      }
      if (required) {
        workingRules = [{
          test: function test(v) {
            return !!v || "".concat(label ? label + " is r" : "R", "equired");
          },
          level: "danger"
        }].concat(_toConsumableArray(workingRules));
      }
      setWorkingValidationState("default");
      setError(null);
      for (var i = 0; i < workingRules.length; i++) {
        var _error = workingRules[i].test(testValue);
        if (_error !== true) {
          setError(_error);
          setWorkingValidationState(workingRules[i].level || "danger");
          return {
            message: _error,
            level: workingRules[i].level || "danger"
          };
        }
      }
    }
  };
  var reset = function reset() {
    setWorkingValidationState(validationState);
    setError("");
  };
  var inputBaseProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: combinedRef,
    className: "a-textarea",
    focused: isFocused,
    error: error,
    hint: hint,
    label: label,
    labelFor: "a-textarea__field_".concat(textareaId),
    disabled: disabled,
    readOnly: readOnly,
    validationState: workingValidationState,
    required: required
  });
  if (autoGrow) {
    inputBaseProps.className += " a-textarea--auto-grow";
  }
  if (propsClassName) {
    inputBaseProps.className += " ".concat(propsClassName);
  }
  var fieldProps = {
    className: "a-textarea__field",
    id: "a-textarea__field_".concat(textareaId),
    disabled: disabled,
    maxLength: maxLength,
    placeholder: placeholder,
    readOnly: readOnly,
    rows: rows,
    value: value,
    onBlur: function onBlur(e) {
      setIsFocused(false);
      validate(e.target.value);
      _onBlur && _onBlur(e);
    },
    onChange: function onChange(e) {
      if (autoGrow) {
        calculateInputHeight();
      }
      !validateOnBlur && validate(e.target.value);
      propsOnChange && propsOnChange(e);
    },
    onFocus: function onFocus(e) {
      setIsFocused(true);
      _onFocus && _onFocus(e);
    },
    onKeyUp: onKeyUp,
    onPaste: onPaste
  };
  if (disableGrammarly) {
    fieldProps["data-gramm"] = false;
  }
  return /*#__PURE__*/React.createElement(AInputBase, inputBaseProps, /*#__PURE__*/React.createElement("textarea", fieldProps));
});
ATextarea.propTypes = {
  /**
   * Toggles whether the textarea auto-focuses on mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Toggles height resize behavior based on content length.
   */
  autoGrow: PropTypes.bool,
  /**
   * Toggles the disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Toggles whether to disable the Grammarly browser extension.
   */
  disableGrammarly: PropTypes.bool,
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Sets the label content.
   */
  label: PropTypes.node,
  /**
   * Sets the maximum length of the textarea value.
   */
  maxLength: PropTypes.number,
  /**
   * Handles the `blur` event
   */
  onBlur: PropTypes.func,
  /**
   * Handles the `change` event.
   */
  onChange: PropTypes.func,
  /**
   * Handles the `focus` event.
   */
  onFocus: PropTypes.func,
  /**
   * Handles the `keyUp` event.
   */
  onKeyUp: PropTypes.func,
  /**
   * Handles the `paste` event.
   */
  onPaste: PropTypes.func,
  /**
   * Sets the textarea placeholder text.
   */
  placeholder: PropTypes.string,
  /**
   * Toggles the read-only state.
   */
  readOnly: PropTypes.bool,
  /**
   * Toggles a default rule for required values.
   */
  required: PropTypes.bool,
  /**
   * Sets the default number of rows for the textarea.
   */
  rows: PropTypes.number,
  /**
   * Sets validation rules for the component.
   */
  rules: PropTypes.arrayOf(PropTypes.shape({
    test: PropTypes.func,
    level: PropTypes.string
  })),
  /**
   * Delays validation until the `blur` event.
   */
  validateOnBlur: PropTypes.bool,
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"]),
  /**
   * Sets the textarea value.
   */
  value: PropTypes.string,
  /**
   * By default the hint hides on error and becomes an AAlert if no
   * error message is specified. Disable to show both hint and error.
   * Default: false
   */
  hideHintOnError: PropTypes.bool
};
ATextarea.displayName = "ATextarea";
export default ATextarea;